var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowUpLight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.5549 45.0252C66.0259 45.4963 66.2614 46.0611 66.2614 46.7198C66.2614 47.3785 66.0259 47.9433 65.5549 48.4144L59.3768 54.5549C58.9058 55.0259 58.3472 55.2615 57.701 55.2615C57.0549 55.2615 56.4963 55.0259 56.0252 54.5549L36.2614 34.7911L16.4977 54.5549C16.0266 55.0259 15.468 55.2615 14.8219 55.2615C14.1757 55.2615 13.6171 55.0259 13.146 54.5549L6.96804 48.4144C6.49698 47.9433 6.26144 47.3785 6.26144 46.7198C6.26144 46.0611 6.49698 45.4963 6.96804 45.0252L34.5856 17.4451C35.0567 16.9741 35.6153 16.7386 36.2614 16.7386C36.9076 16.7386 37.4662 16.9741 37.9373 17.4451L65.5549 45.0252Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowUpLight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-up-light.b2c6061e5d5cc5648f3ee35d7b55ca9b.svg";